module.exports = __webpack_public_path__ + "static/media/A1-21-Uzen-cod119-B.00e9b567.png";